export type PresetId = "today" | "7d" | "30d"

/**
 * 로컬 달력 기준 YYYY-MM-DD. toISOString 은 UTC 라 한국·일본 0~9시에는 전날이 된다.
 * 날짜 입력칸의 기본값("오늘")은 모두 이것을 쓴다.
 */
export function toDateString(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, "0")
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

const DAYS: Record<PresetId, number> = { today: 1, "7d": 7, "30d": 30 }

export const PRESET_IDS: PresetId[] = ["today", "7d", "30d"]

/** 오늘을 포함해 N일. 7d 면 오늘과 지난 6일. */
export function presetRange(id: PresetId, today: Date): { from: string; to: string } {
  const from = new Date(today)
  from.setDate(from.getDate() - (DAYS[id] - 1))
  return { from: toDateString(from), to: toDateString(today) }
}

/** 지금 범위가 어느 프리셋인지. 아니면 null(= 직접 입력). */
export function matchPreset(
  from: string | null,
  to: string | null,
  today: Date,
): PresetId | null {
  if (!from || !to) return null
  for (const id of PRESET_IDS) {
    const range = presetRange(id, today)
    if (range.from === from && range.to === to) return id
  }
  return null
}
